import { useEffect } from 'react';

interface PaginationState { current: number; pageSize: number; total: number }
interface SortConfig { field?: string; order?: 'ascend' | 'descend' }

export function useOrdersEffects(params: {
  isInitialized: React.MutableRefObject<boolean>;
  pagination: PaginationState;
  setPagination: (p: PaginationState | ((prev: PaginationState) => PaginationState)) => void;
  updateUrlParams: (p: { current: number; pageSize: number; total?: number }) => void;
  fetchOrders: () => void | Promise<void>;
  // dependencies
  searchText: string;
  searchField: string;
  serviceFilter?: string;
  subServiceFilter?: string;
  filters: Record<string, any>;
  sortConfig: SortConfig;
}) {
  const { isInitialized, pagination, setPagination, updateUrlParams, fetchOrders, searchText, searchField, serviceFilter, subServiceFilter, filters, sortConfig } = params;

  // 搜索、筛选、排序变化时重置到第一页/拉取数据
  useEffect(() => {
    if (!isInitialized.current) return;
    if (pagination.current !== 1) {
      const newPagination = { ...pagination, current: 1 };
      setPagination(newPagination);
      updateUrlParams(newPagination);
    } else {
      fetchOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, searchField, serviceFilter, subServiceFilter, filters, sortConfig.field, sortConfig.order]);

  // 分页变化时获取数据
  useEffect(() => {
    if (!isInitialized.current) return;
    if (pagination.current > 0 && pagination.pageSize > 0) {
      fetchOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize]);
}
